import { ArrowUpRight } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/* RIOTBALL clash banner — pure CSS arena: red and white halves trade the glow,
   a rally ball rolls the baseline, and the score line shows the LIVE league records. */
export function RiotballAd() {
  const [league, setLeague] = useState(null); // {red, white} — live all-time best marks per side

  useEffect(() => {
    let alive = true;
    fetch(`${API}/riotball/records`)
      .then((r) => r.json())
      .then((d) => {
        if (alive) setLeague({ red: d.red || 0, white: d.white || 0 });
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return (
    <section className="riotball-ad" data-testid="riotball-ad-section">
      <Reveal className="riotball-clash">
        <div className="riotball-half is-red" aria-hidden="true" />
        <div className="riotball-half is-white" aria-hidden="true" />
        <span className="riotball-rally" aria-hidden="true" />
        <div className="riotball-clash-copy">
          <p className="eyebrow">ALLIANCE LEAGUE // 60-SECOND ARENA</p>
          <h2>AL RIOTBALL</h2>
          <p className="riotball-clash-line" data-testid="riotball-live-score">
            RED FORCE <b>{league ? league.red : "—"}</b> — <b>{league ? league.white : "—"}</b> WHITE GUARD ·{" "}
            {league ? "LEAGUE RECORDS LIVE" : "CHAMPIONSHIP SEASON LIVE"}
          </p>
        </div>
        <span className="riotball-vs" aria-hidden="true">
          VS
        </span>
        <Link to="/riotball" className="riotball-enter" data-testid="riotball-ad-link">
          ENTER THE ARENA <ArrowUpRight size={15} />
        </Link>
      </Reveal>
    </section>
  );
}
